import { Plus, Gift, Mail, Crosshair, Award, Home, Handshake, Megaphone, Tag, CalendarClock, SlidersHorizontal } from 'lucide-react';

const additionalSections = [
    {
        key: 'schedule',
        icon: CalendarClock,
        title: 'Layout e programação',
        description: 'Monte a programação por sessões e escolha quais ingressos dão acesso a cada uma.',
        comingSoon: false,
        getBadge: (data) => {
            if (data?.layout !== 'schedule') {
                return 'Padrão';
            }
            const count = data?.sessions?.length || 0;
            return count > 0 ? `${count} ${count > 1 ? 'sessões' : 'sessão'}` : 'Sem sessões';
        }
    },
    {
        key: 'customFields',
        icon: Plus,
        title: 'Campos personalizados',
        description: 'Colete informações extras dos participantes durante a inscrição.',
        comingSoon: false,
        getBadge: (data) => {
            const count = data?.customFields?.length || 0;
            return count > 0 ? `${count} campo${count > 1 ? 's' : ''}` : 'Nenhum';
        }
    },
    {
        key: 'giveaway',
        icon: Gift,
        title: 'Sorteador',
        description: 'Faça sorteios e distribua prêmios entre os participantes.',
        comingSoon: false,
        getBadge: (data) => {
            const count = data?.giveaways?.length || 0;
            return count > 0 ? `${count} sorteio${count > 1 ? 's' : ''}` : 'Nenhum';
        }
    },
    {
        key: 'faq',
        icon: Mail,
        title: 'FAQ do evento',
        description: 'Crie uma seção de Perguntas Frequentes para seus participantes.',
        comingSoon: false,
        getBadge: (data) => {
            const count = data?.faq?.length || 0;
            return count > 0 ? `${count} pergunta${count > 1 ? 's' : ''}` : 'Nenhum';
        }
    },
    {
        key: 'pixels',
        icon: Crosshair,
        title: 'Pixels de rastreamento',
        description: 'Monitore conversões e otimize suas campanhas.',
        comingSoon: false,
        getBadge: (data) => {
            const count = data?.pixels?.length || 0;
            return count > 0 ? `${count} pixel${count > 1 ? 's' : ''}` : 'Nenhum';
        }
    },
    {
        key: 'campaigns',
        icon: Megaphone,
        title: 'Campanhas',
        description: 'Veja qual origem de tráfego está trazendo venda para o evento.',
        comingSoon: false,
        getBadge: (data) => {
            const count = data?.campaigns?.campanhas?.filter(item => item.atribuido).length || 0;
            return count > 0 ? `${count} campanha${count > 1 ? 's' : ''}` : 'Nenhuma';
        }
    },
    {
        key: 'certificate',
        icon: Award,
        title: 'Geração de certificados',
        description: 'Crie e personalize certificados para os participantes.',
        comingSoon: false,
        getBadge: (data) => {
            return data?.certificate ? 'Configurado' : 'Nenhum';
        }
    },
    {
        key: 'labels',
        icon: Tag,
        title: 'Etiquetas',
        description: 'Gere etiquetas de identificação para os participantes do seu evento.',
        comingSoon: false,
        getBadge: (data) => {
            return data?.labels?.configured ? 'Configurado' : 'Nenhum';
        }
    },
    {
        key: 'sponsors',
        icon: Handshake,
        title: 'Patrocinadores e apoiadores',
        description: 'Destaque patrocinadores, apoiadores, parceiros e mantenedores do seu evento.',
        comingSoon: false,
        getBadge: (data) => {
            const count = data?.sponsorSections?.length || 0;
            return count > 0 ? `${count} seção${count > 1 ? 'ões' : ''}` : 'Nenhuma';
        }
    },
    {
        key: 'settings',
        icon: SlidersHorizontal,
        title: 'Configurações avançadas',
        description: 'Check-in por dia ou único, transferência de ingresso, uma compra por pessoa e regras de presença.',
        comingSoon: false,
        getBadge: (data) => {
            const active = [
                data?.settings?.checkin_mode === 'per_day' && 'Check-in por dia',
                data?.settings?.one_order_per_user && '1 compra por pessoa',
            ].filter(Boolean);

            return active.length ? active.join(' · ') : 'Padrão';
        }
    },
    {
        key: 'local',
        icon: Home,
        title: 'Características do local',
        description: 'Destaque as características e comodidades do local do evento.',
        comingSoon: false,
        getBadge: (data) => {
            const count = data?.features?.length || 0;
            return count > 0 ? `${count} característica${count > 1 ? 's' : ''}` : 'Nenhuma';
        }
    }
];

export default additionalSections;
